import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client.ts'
import { Avatar } from './Avatar.tsx'
import { useChats } from '../store/chats.ts'
import { plural } from '../lib/format.ts'

/**
 * Куда переслать.
 *
 * Список тот же, что и в боковой панели, — человек ищет переписку там,
 * где привык её видеть. Отдельного поиска по людям не делаем: в семье
 * переписок единицы, а лишнее поле только мешает.
 */
export function ForwardDialog({
  messageIds,
  fromChatId,
  onClose,
  onDone,
}: {
  messageIds: string[]
  fromChatId: string
  onClose: () => void
  onDone: () => void
}) {
  const chats = useChats((s) => s.chats)
  const loadChats = useChats((s) => s.loadChats)
  const navigate = useNavigate()

  const [busy, setBusy] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const forward = async (toChatId: string) => {
    setBusy(toChatId)
    setError(null)
    try {
      await api('/api/messages/forward', {
        method: 'POST',
        body: { messageIds, toChatId },
      })
      await loadChats()
      onDone()
      onClose()
      // Переходим туда, куда переслали: иначе непонятно, случилось ли что-то
      if (toChatId !== fromChatId) navigate(`/chat/${toChatId}`)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не получилось переслать')
    } finally {
      setBusy(null)
    }
  }

  return (
    <div className="sheet" onClick={onClose}>
      <div className="sheet-body" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-head">
          <h2>Переслать</h2>
          <button className="icon-btn" onClick={onClose} aria-label="Закрыть">
            ✕
          </button>
        </div>

        <p className="sheet-text">
          {messageIds.length} {plural(messageIds.length, 'сообщение', 'сообщения', 'сообщений')} —
          выбери, куда
        </p>

        <div className="member-list">
          {chats.map((chat) => (
            <button
              key={chat.id}
              className="member-row pick"
              onClick={() => void forward(chat.id)}
              disabled={busy !== null}
            >
              <Avatar id={chat.id} name={chat.title} url={chat.avatarUrl} size={40} />
              <div className="member-text">
                <div className="member-name">{chat.title}</div>
                {chat.kind !== 'DIRECT' && (
                  <div className="member-sub">
                    {chat.membersCount}{' '}
                    {plural(chat.membersCount, 'участник', 'участника', 'участников')}
                  </div>
                )}
              </div>
              {busy === chat.id && <span className="spinner" style={{ marginLeft: 'auto' }} />}
            </button>
          ))}
        </div>

        {error && <div className="sheet-error">{error}</div>}
      </div>
    </div>
  )
}
